import { useEffect, useContext, useRef } from "react";
import { showNotification } from "../../utils/showNotification";
import useNotificationPermission from "../../hooks/useNotificationPermission.hook";
import { AuthContext } from '../../context/AuthContext';
import callStaff from '../../assets/img/callstaff.png';
import reserved from '../../assets/img/reservation.png';

const NotificationHandler = ({
  isAuthenticated = false
}) => {
  const permission = useNotificationPermission();
  const auth = useContext(AuthContext);
  const socketRef = useRef(null); // Хранит текущее соединение WebSocket
  const retryCount = useRef(0);
  const maxRetries = 5; // Максимальное количество попыток переподключения
  const reconnectInterval = 3000; // Интервал между попытками переподключения в миллисекундах

  useEffect(() => {
    if (permission !== "granted" || isAuthenticated === false) return;

    // Если уже есть открытое соединение, выходим
    if (socketRef.current) return;

    // Функция для подключения к WebSocket
    const connectWebSocket = () => {
      socketRef.current = new WebSocket(
        process.env.NODE_ENV === "development"
          ? `ws://127.0.0.1:8000/api/ws/${auth.token}`
          : `wss://lk.egcounts.space/api/ws/${auth.token}`
      );

      socketRef.current.onopen = () => {
        retryCount.current = 0; // Сбрасываем счетчик при успешном подключении
      };

      socketRef.current.onmessage = (event) => {
        const data = JSON.parse(event.data);

        // Отображаем уведомление в зависимости от типа действия
        if (data.action === 'reserved') {
          showNotification("Новая заявка на бронирование", {
            body: `Рассмотрите новую заявку на бронирование`,
            icon: reserved,
          });
        } else if(data.action === 'call_staff') {
          showNotification("Вызов персонала", {
            body: `Подойдите к столику: ${data.table_id}`,
            icon: callStaff,
          });
        } else if(data.action === 'external'){
          showNotification("Другое действие", {
            body: data.message,
            // icon: callStaff,
          });
        }
      };

      socketRef.current.onerror = (error) => {
        console.error("WebSocket ошибка:", error);
      };

      socketRef.current.onclose = (event) => {

        // Если соединение закрыто нештатно, пробуем переподключиться
        if (!event.wasClean && retryCount.current < maxRetries) {
          retryCount.current += 1;
          setTimeout(connectWebSocket, reconnectInterval);
        } else {
          // Убираем ссылку на сокет, если достигли максимального количества попыток
          socketRef.current = null;
        }
      };
    };

    // Инициируем WebSocket соединение
    connectWebSocket();

    // Закрываем соединение при размонтировании компонента
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
        socketRef.current = null; // Сбрасываем ссылку на сокет при размонтировании
      }
    };
  }, [permission, auth.token, isAuthenticated]); // Запускаем useEffect при изменении разрешений и токена

  return null;
};

export default NotificationHandler;
